import { createColumnHelper } from '@tanstack/react-table';
import { TableMetaCustom } from '@app/types/overrides/table-meta';
import MainTableRowActions from '@components/MainTable/MainTableRowActions';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { IconPencil, IconTrash } from '@tabler/icons-react';
import { Typography } from '@mui/material';
import { dateFromString } from '@utils/utils.ts';
import { DocumentTemplate } from '@app/types/document-template';

const columnHelper = createColumnHelper<DocumentTemplate>();

export const documentTemplateTableColumns = [
  columnHelper.accessor('name', {
    id: 'name',
    header: 'Name',
    enableSorting: true,
    size: 100,
    enableResizing: false,
  }),
  columnHelper.accessor('created_at', {
    id: 'created_at',
    header: 'Created At',
    enableSorting: true,
    size: 100,
    enableResizing: false,
    cell: ({ row: { original } }) => (
      <Typography variant="body2">
        {dateFromString(new Date(original.created_at))}
      </Typography>
    ),
  }),
  columnHelper.accessor('updated_at', {
    id: 'updated_at',
    header: 'Updated At',
    enableSorting: true,
    size: 100,
    enableResizing: false,
    cell: ({ row: { original } }) => (
      <Typography variant="body2">
        {dateFromString(new Date(original.updated_at))}
      </Typography>
    ),
  }),
  columnHelper.accessor('id', {
    id: 'id',
    header: 'Actions',
    enableSorting: false,
    enableResizing: false,
    cell: ({
      row: { original },
      table: {
        options: { meta },
      },
    }) => {
      const tableMeta = meta as TableMetaCustom<typeof original>;

      return (
        <MainTableRowActions>
          <>
            <Tooltip title="Edit Document">
              <IconButton
                onClick={() => {
                  tableMeta?.handleEditRow &&
                    tableMeta?.handleEditRow(original);
                }}
              >
                <IconPencil />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete Document">
              <IconButton
                onClick={() => {
                  tableMeta?.handleDeleteRow &&
                    tableMeta?.handleDeleteRow(original);
                }}
              >
                <IconTrash />
              </IconButton>
            </Tooltip>
          </>
        </MainTableRowActions>
      );
    },
  }),
];
